<template>
  <div>
    <el-form :inline="true" :size="size" class="form">
      <!-- 汇总级别 -->
      <el-form-item :label="$t('runState.summaryLevel')">
        <el-select v-model="level" :placeholder="$t('public.select')" :size="size" style="width:110px;margin-right:6px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select 
          v-model="levelDeal" 
          :placeholder="$t('public.select')" 
          style="width:180px" 
          multiple
          :size="size"
          :loading="mulSelectLoading"
          :collapse-tags="collapseTags"
          @change='changeSelect'
          @remove-tag='removeTag'
        >
          <!-- :multiple="DealOptions[level].length > 1 ? true : false" v-if="isMulti" -->
          <el-option :label="$t('runState.allSelect')" value="全选" @click.native="selectAll" v-if="DealOptions.length > 0 && DealOptions[level].length > 0"></el-option>
          <el-option
            v-for="item in DealOptions[level]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            filterable>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
	import {mapState} from 'vuex'
export default {
  props:{
    collapseTags:{
      type:Boolean,
      default:true,
    },
    mulSelectLoading:{
      type:Boolean,
      default:false,
    },
    DealOptions:{
      type:Array,
      default:function () {
        return [] 
      }
    }
  },
  data(){
    return{
      level:0,
      levelDeal:"",
      options:[],
      allGroupIDs:"",
      mulSelecteds:[],
      isAll:false,
      isMulti:false,
    }
  },
  computed:{
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      operator: state => state.user.operator,
    }),
  },
  watch:{
    mulSelectLoading(newVal,oldVal){
      if(oldVal && !newVal){
        this.mulSelecteds = ["全选",this.operator.CompanyId];
        setTimeout(() => {
          this.$emit("getLevel",{mulSelecteds:this.mulSelecteds,isAll:true,isFirst:true});//,all:this.allGroupIDs
        },1)
      }
    },
    level(newVal){
      // console.log(this.DealOptions[newVal]);
      this.isMulti = this.DealOptions[this.level].length > 1 ? true : false;
      this.levelDeal = this.mulSelecteds = "";
      // console.log(this.levelDeal);
    },
    mulSelecteds:{
      handler(newVal,oldVal){
        this.levelDeal = newVal;
        if(Array.isArray(newVal)){
          if (!this.levelDeal.includes('全选') && 
               this.levelDeal.length && 
               this.levelDeal.length === this.DealOptions[this.level].length) 
          {
            this.levelDeal.unshift('全选');
            this.isAll = true;
          }

        }
        setTimeout(() => {
          this.$emit("getLevel",{mulSelecteds:this.mulSelecteds,isAll:this.isAll});//,all:this.allGroupIDs
        },1)
      },
      immediate: true
    },
  },
  methods:{
    selectAll() {
      
      if (this.levelDeal.length < this.DealOptions[this.level].length) {
        this.levelDeal = []
        this.DealOptions[this.level].map((item) => {
          this.levelDeal.push(item.value)
        })
        this.levelDeal.unshift('全选');
        this.isAll = true;
        // console.log("isSeletAll");
      } else {   // 取消全选
        this.levelDeal = [];
        this.isAll = false;
        // console.log("cancleSeletAll");
      }
      // this.$emit('update:updateMultipleSelect',this.levelDeal);
      this.mulSelecteds = this.levelDeal; 
    },
    changeSelect(val) {
      // console.log(val);
      if(Array.isArray(val)){
        if (!val.includes('全选') && val.length === this.DealOptions[this.level].length) {
          this.levelDeal.unshift('全选');
          // console.log("11111111111111111111")
          this.isAll = true;
        } else if (val.includes('全选') && (val.length - 1) < this.DealOptions[this.level].length) {
          this.levelDeal = this.levelDeal.filter((item) => { return item !== '全选'});
          // console.log("222222222222222222222")
          this.isAll = false;
        }

      }
      // this.$emit('update:updateMultipleSelect',this.levelDeal);
      this.mulSelecteds = this.levelDeal; 
      // setTimeout(() => {
      //   this.$emit("getLevel",{mulSelecteds:this.mulSelecteds,isAll:this.isAll});//,all:this.allGroupIDs
      // },1)
    },
    removeTag(val) {
      if (val === '全选') {
        this.levelDeal = [];
        this.isAll = false;
        // this.$emit('update:updateMultipleSelect',this.levelDeal);
        this.mulSelecteds = this.levelDeal; 
      }
    },

    
  },
  mounted(){
    //初始化汇总级别
    this.options = [
      {
        value: 0,
        label: this.$t("organstructure.headoffice"),
      },
      {
        value: 1,
        label: this.$t("organstructure.branch"),
      },
      {
        value: 2,
        label: this.$t("runState.fleet"),
      },
      {
        value: 3,
        label: this.$t("runState.route"),
      },
    ];
    // console.log(this.DealOptions);
    // this.getLevel(0);
  },
}
</script>
<style lang="scss" scoped>
.form  {
  ::v-deep .el-form--inline .el-form-item {
      margin-bottom: 0px !important;
  }
}
::v-deep .el-select__tags {  //待
    flex-wrap: inherit !important;
     overflow-x: auto !important;
}

</style>